import {
  PatientInsurance,
  PatientInsuranceControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  patientInsurance: PatientInsurance[];
  xTENANTID?: string;
}

export const useCreatePatientInsurance = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientInsuranceControllerApi(getConfigObject()).createPatientInsurance(
      params.patientInsurance,
      params.xTENANTID
    )
  );
